<template>
  <div>
    <zj-layout-container>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <h1>上传 Demo</h1>
          <el-upload
            :http-request="httpRequest"
            :data="uploadData"
            :file-list="fileList"
            :before-upload="beforeupload"
            :on-success="uploadsuccess"
            :on-progress="uploadProgress"
            :on-error="uploadError"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import ZJApp from "../../../../app";
export default {
  name: "ZjDemoUpload",
  controller: "UI",
  action: "Upload",
  data() {
    return {
      uploadData: {
        module: "Demo", //模块名
        submodule: "", //子模块
        assocID: "", //业务ID
        uploader: "TEST", //上传人
        folder: "", //上传目录，服务器按如下格式拼装：/{module}/{submodule}/{folder}
        ext1: "", //扩展字段 1
        ext2: "", //扩展字段 2
        ext3: 0 //扩展字段 3
      },
      fileList: []
    };
  },
  computed: {
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
    }
  },
  methods: {
    beforeupload: function() {
      this.uploadData.assocID = ZJApp.ZJUtils.uuid();
      this.loading = true;
      this.loadingText = "上传中... 0%";
    },
    uploadsuccess: function() {
      this.loading = false;
    },
    uploadError(err) {
      console.error("上传失败: ", err);
      this.errmsg("上传失败: " + err);
      this.loading = false;
    },
    uploadProgress(e) {
      this.loadingText = "上传中... " + parseInt(e.percent) + "%";
    },
    handlePreview(file) {
      console.log(file);
      document.location.href = file.url;
    }
  }
};
</script>
